import Choices from 'choices.js';
import NiceSelect from "../../../node_modules/nice-select2/dist/js/nice-select2";

export default new class Select {
    constructor() {
        this.init();
    }

    init() {

        document.querySelectorAll("select.choices-select").forEach(function(element){
            const choices = new Choices(element, {
                searchEnabled: false,
                shouldSort: false
            });
        });

        document.querySelectorAll("select.choices-ajax").forEach(function(element){

            let emptyResultsText        = element.getAttribute('data-empty-results');
            let searchPlaceholderText   = element.getAttribute('data-search-placeholder');

            let choice = new Choices(element, {
                searchEnabled: true,
                searchResultLimit: 10,
                noResultsText: emptyResultsText,
                noChoicesText: '',
                removeItemButton: true,
                placeholderValue: 'Місто',
                searchPlaceholderValue: searchPlaceholderText || 'Введіть назву',
            });

            let method = element.getAttribute('data-method');

            element.addEventListener('search', async (e) => {
                
                let term = e.detail.value;
                let refNode = `[name="address[ref]"]`;
                let refSelector = document.querySelector(refNode);

                let ref = null;
                if(refSelector != null) {
                    ref = refSelector.value;
                }

                let data = await oc.ajax('basic::onSearch', {
                    data: {term, method, ref}
                });
                choice.setChoices(data, 'id', 'text', true);
            });

            element.addEventListener('choice', (item) => {

                const method = item.detail.choice.customProperties.method;
                const ref = item.detail.choice.customProperties.ref;
                
                if(typeof method !== 'undefined'){
                    if(ref !== 'undefined' && method === 'cities') {
                        let refNode = `[name="address[ref]"]`;
                        document.querySelector(refNode).value = ref;
                    } 
                }
                    
            });
        });

        document.querySelectorAll("select.nice-select2").forEach(function(element){

            if(element.nextElementSibling != null && element.nextElementSibling.matches('.nice-select')){ 
                return;
            }

            new NiceSelect(element, {
                searchable: false, 
                placeholder: 'select'
            });
        });
    }
}();